export type DayType = 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday';

const DAYS: DayType[] = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
// THIS DATE FORMAT IS REQUIRED FOR INPUT TYPE 'DATE' TO WORK
export const FORMAT_DATE = 'YYYY-MM-DD';
// ------------------------------------
export const DEFAULT_FORMAT_DATE_INPUT_US = 'MM-DD-YYYY';
export const DEFAULT_FORMAT_DATE_US = 'MM/DD/YYYY';
export const FORMAT_DATE_FOR_DISPLAY = 'ddd, MMM D, YYYY';
export const FORMAT_DATE_FOR_DISPLAY_FULL = 'MMMM Do YYYY, h:mm:ss a';
// export const FORMAT_DATE_FOR_DISPLAY = 'ddd, MMM D, yyyy';
export const FORMAT_TIME = 'HH:mm';
export const FORMAT_DATE_TIME = `${FORMAT_DATE} ${FORMAT_TIME}`;
export const FORMAT_DATE_TIME_US_FOR_DISPLAY = `${DEFAULT_FORMAT_DATE_INPUT_US} ${FORMAT_TIME}`;
export const FORMAT_DATE_TIME_FOR_DISPLAY = `${FORMAT_DATE_FOR_DISPLAY} ${FORMAT_TIME}`;

export const formatDateTimeForDisplay = (separator: string, formatDate?: string, formatTime?: string) =>
  `${formatDate || FORMAT_DATE_FOR_DISPLAY}${separator ? ` ${separator} ` : ' '}${formatTime || FORMAT_TIME}`;

export default DAYS;
